import { apiRequest } from "./common";

const createProject = async (data) => {
    const response = await apiRequest('post', '/project-bank', data);
    return response.data;
};

const updateProject = async (id, data) => {
    const response = await apiRequest('put', `/project-bank/${id}`, data);
    return response.data;
};

const deleteProject = async (id) => {
    const response = await apiRequest('delete', `/project-bank/${id}`);
    return response.data;
};

const getProjectList = async (pageNo, pageSize, projectType, projectLevel, category) => {
    const response = await apiRequest('get', `/project-bank/list?page=${pageNo}&limit=${pageSize}${projectType !== '' ? `&project_type=${projectType}` : ''}${projectLevel !== '' ? `&project_level=${projectLevel}` : ''}${category !== '' ? `&categories=${category}` : ''}`);
    return response.data;
};

const getProjectByStudent = async (studentId, projectSource) => {
    const response = await apiRequest('get', `/project/by-student/${studentId}?includeField=true&projectSource=${projectSource}`);
    return response.data;
};

const skipIntakeForm = async (data) => {
    const response = await apiRequest('post', `/project-intake/skip`, data);
    return response.data;
};

const saveIntakeForm = async (data) => {
    const response = await apiRequest('post', `/project-intake`, data);
    return response.data;
};

const getprojectProgress = async (projectId) => {
    const response = await apiRequest('get', `/project/${projectId}/progress`);
    return response.data;
};

const getProject = async (projectId) => {
    const response = await apiRequest('get', `/project/${projectId}`);
    return response.data;
};

const getMentorProject = async (studentId, mentorId) => {
    const response = await apiRequest('get', `/project/by-student-mentor/${studentId}/${mentorId}`);
    return response.data;
};

export {
    createProject,
    updateProject,
    deleteProject,
    getProjectList,
    getProjectByStudent,
    skipIntakeForm,
    saveIntakeForm,
    getprojectProgress,
    getProject,
    getMentorProject
};
